function B3() {
    return (
        <main className='main'>
            <h2>Опис трудових функцій; професійні компетентності; знання, уміння та навички</h2>
            <table>
                <tr>
                    <td colSpan="3">
                        БЗ Комунікативна
                    </td>
                </tr>
                <tr className='bold'>
                    <td>Професійні компетентності (за трудовою дією або групою трудових дій)</td>
                    <td>Знання</td>
                    <td>Уміння та навички</td>
                </tr>
                <tr>
                    <td rowSpan="4">
                        Б3.1 Здатність до ефективної комунікації з учасниками освітнього процесу та органами влади, іншими організаціями, представниками громади
                    </td>
                    <td>
                        Б3.1.31 Основи та техніки ефективних комунікацій, антикризові комунікації
                    </td>
                    <td>
                        Б3.1.У1 Організовувати та здійснювати комунікацію, використовувати техніки ефективних та антикризових комунікацій всередині колективу
                    </td>
                </tr>
                <tr>
                    <td>
                        Б3.1.32 Інформаційний простір та канали комунікації
                    </td>
                    <td>
                        Б3.1.У2 Обирати та використовувати оптимальні канали комунікації в залежності від її цілей
                    </td>
                </tr>
                <tr>
                    <td>
                        Б3.1.33 Основи комунікації та партнерської взаємодії з батьками
                    </td>
                    <td>
                        БЗ.1.УЗ Комунікувати з батьками як з рівноправними учасниками освітнього процесу
                    </td>
                </tr>
                <tr>
                    <td>
                        Б3.1.34 Компетенції органів місцевої влади у сфері управління освітою
                    </td>
                    <td>
                        БЗ.1.У4 Організовувати та здійснювати ефективні комунікації з органами місцевої влади у сфері управління освітою, іншими організаціями, представниками різних професійних груп та громади відповідно до їхньої компетенції
                    </td>
                </tr>
            </table>
        </main>
    )
}

export {B3}